////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { map, cloneDeep, find, reject, isUndefined, filter } from 'lodash'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import ListSearchable from '../../../components/ListSearchable'
import { tagsManagerActionCreators } from '../../../store/actions'
import { PageGridBorder, InputLogin, SearchInputWrapper, SearchInputButton, SearchReset, ReverseShiftItemButton } from '../../../theme/GlobalCss'

//////STYLED//////
const TagsListAffectedManagerWrapper = styled.div`
	position: relative;
	border: ${(props) => `1px solid ${props.theme.colors.primary}`};
	border-radius: 4px;
	& > div {
		border-radius: 0px;
		border: 0px;
	}
`
const ListActions = styled.div`
	position: relative;
	padding: 10px;
	display: flex;
	flex-direction: row;
`
const UnaffectedSearchWrapper = styled.div`
	position: relative;
	& > * > input {
		font-size: ${(props) => props.theme.font.fs};
	}
`
const PageGridTitleStyled = styled.div`
	text-align: center;
	color: ${(props) => props.theme.colors.white};
	background-color: ${(props) => props.theme.colors.primary};
	padding: 13px;
`
const PageGridTitleStyledSpan = styled.span`
	display: block;
	margin: auto;
	& > b {
		font-size: ${(props) => props.theme.font.fl};
	}
`
//////STYLED//////

const TagsListAffectedManager = (props) => {
	const [searchValue, setSearchValue] = useState('')
	const [searched, setSearched] = useState('')

	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			tagsManager: state.tagsManager,
		}),
		shallowEqual
	)

	const [allData, setAllData] = useState([...props.baseData, ...props.baseDataUnaff])
	const [inputData, setInputData] = useState(props.baseData) // Current data shown
	const [baseSearch, setBaseSearch] = useState() // Database of searching

	const actionsTagsManager = bindActionCreators(tagsManagerActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleInputData = (triggerShift, arrToPass) => {
		let newinputData = cloneDeep(inputData)

		// Every item that was in unaffected list (checked items), we add to this list
		if (props.listObjUnaffected.length > 0) {
			map(props.listObjUnaffected, (elem, _id) => {
				const r = filter(newinputData, (o) => o.id === elem.id)

				// If unaffected item is not in our current list, we add it
				return r.length === 0 ? newinputData.push(elem) : null
			})
		}

		// But also cutting objects that were shifted,
		// at any time so filters can work properly
		if (triggerShift) {
			map(arrToPass, (elem) => {
				newinputData = reject(newinputData, elem)
			})

			// Send items to unaffected manager
			props.setListObjAffected(arrToPass)
			// Reset checked list
			props.setListAffected([])
		}

		setInputData(newinputData)
		// Everytime that items are added / remove, we redraw the search base
		setBaseSearch(newinputData)
		// And we also refresh what id currently shifted (by sum of all shifting actions)
		props.handleShiftedDataToRemove(newinputData)
	}

	const handleListObjAffected = () => {
		let arrToPass = []
		let r
		map(props.listAffected, (elem, _id) => {
			// We want to push objects, not ids,
			// so we are searching on all data available, unaffected and affected !
			r = find(allData, (o) => o.id === elem)
			if (!isUndefined(r)) {
				arrToPass.push(r)
			}
		})

		handleInputData(true, arrToPass)
	}

	const handleSearchValue = (e) => {
		setSearchValue(e.target.value)
	}

	const handleSearch = (_e) => {
		setSearched(searchValue)
	}

	const handleSearchEnter = (e) => {
		if (e.keyCode === 13 || searchValue === '') setSearched(searchValue)
	}

	// Handling of filters
	const handleGlobalSearch = () => {
		// Note that we always start from searchBase, not current input,
		// Otherwise everytime we are filtering, we are removing elements !
		if (!isUndefined(baseSearch)) {
			if (searchValue.length > 0) {
				let b_s = cloneDeep(baseSearch)
				b_s = reject(b_s, (o) => {
					let str = props.mode === 'user' ? cloneDeep(o.fullName) : cloneDeep(o.description)
					str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
					let transformed_search = cloneDeep(searched)
					transformed_search = transformed_search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
					return str.toUpperCase().includes(transformed_search.toUpperCase()) ? false : true
				})
				setInputData(b_s)
			} else {
				setInputData(baseSearch)
			}
		}
	}

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: props.mode === 'user' ? translations['page__tagManagement__user_user_list'] : translations['page__tagManagement__kiosk_user_list'],
		labelSelected:
			props.mode === 'user' ? translations['page__tagManagement__user_selected'] : translations['page__tagManagement__kiosk_selected'],
		filters: {
			searchValue: searched,
		},
	}
	const columns = [
		// We set what data value is used to
		// For setting value of input
		{ isCheckboxValue: true, dataHook: 'id', headerName: 'id' },
		// For labelling the item
		{
			isLabel: true,
			dataHook: props.mode === 'user' ? 'fullName' : 'description',
			headerName: props.mode === 'user' ? 'fullName' : 'description',
			sortable: true,
			alreadyTranslated: true,
			dataCounter: {
				addSymbol: '+',
				column: 'numberOfTagRemain',
				haveTag: true,
				keyword: 'tag',
			},
		},
	]

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		// Whenever we change filters or that we shift data, we redraw the list
		handleInputData()
	}, [props.baseData, props.listObjUnaffected])

	useEffect(() => {
		handleGlobalSearch()
	}, [searched])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TagsListAffectedManagerWrapper>
			<PageGridTitleStyled>
				{config.name}
				<PageGridTitleStyledSpan>
					<b>
						{props.baseData.length}{' '}
						{props.mode === 'user' ? translations['page__tagManagement__user'] : translations['page__tagManagement__kiosk']}
						{/*inputData.length > 1 ? 's':''*/}
					</b>
					{props.listObjUnaffected.length > 0
						? props.mode === 'user'
							? ` (+${props.dataAdded.length} ${translations['page__tagManagement__user_added']})`
							: ` (+${props.dataAdded.length} ${translations['page__tagManagement__kiosk_added']})`
						: ''}
				</PageGridTitleStyledSpan>
			</PageGridTitleStyled>
			<PageGridBorder>
				<ListActions>
					{props.baseData && (
						<UnaffectedSearchWrapper>
							<SearchInputWrapper>
								<InputLogin
									value={searchValue}
									onChange={handleSearchValue}
									onKeyDown={handleSearchEnter}
									placeholder={
										props.mode === 'user'
											? translations['page__tagManagement__user_search']
											: translations['page__tagManagement__kiosk_search']
									}
								/>
								<SearchInputButton onClick={handleSearch} />
							</SearchInputWrapper>
							{searchValue.length > 0 && (
								<SearchReset
									onClick={() => {
										setSearchValue('')
										setSearched('')
									}}
								/>
							)}
						</UnaffectedSearchWrapper>
					)}
				</ListActions>
				{props.baseData && (
					<ListSearchable
						inputData={inputData}
						inputColumns={columns}
						translationMode={true}
						inputConfig={config}
						sizeHeightActions={473}
						readOnly={props.readOnly}
						hookList={props.setListAffected}
						summaryList={props.listAffected}
					/>
				)}
			</PageGridBorder>
			<ReverseShiftItemButton
				onClick={() => handleListObjAffected()}
				active={props.listAffected.length > 0}
				modalMode={props.modalMode}
				disabled={!props.listAffected.length > 0}
			>
				{props.mode === 'user' ? translations['page__tagManagement__user_unlink'] : translations['page__tagManagement__kiosk_unlink']}
			</ReverseShiftItemButton>
		</TagsListAffectedManagerWrapper>
	)
}

TagsListAffectedManager.propTypes = {}

TagsListAffectedManager.defaultPropTypes = {}

export default TagsListAffectedManager
